module.exports = __webpack_public_path__ + "img/logo.60b118fc.png";